<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="paddingContent">
      <div class="contentbox">
        <div class="contentLeft">
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">報名資訊</div>
              <!-- <div class ='cardHeaderRight'>
                <el-select v-model="drawStatus" placeholder="更新報名狀態" size="small" @change="drawStatusChange">
                  <el-option label="已抽中" value="1"></el-option>
                  <el-option label="未抽中" value="2"></el-option>
                </el-select>
              </div> -->
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in drawInfoLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div
                  class="cardRowRight_status"
                  v-if="item.key === 'drawStatus'"
                >
                  {{ drawInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else-if="drawInfo[item.key]">
                  {{ drawInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">活动資訊</div>
            </div>
            <div class="cardBody" v-if="this.free == 1">
              <div
                class="cardRow"
                v-for="(item, index) in activityInfoLabels"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="activityInfo[item.key]">
                  {{ activityInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
            <div class="cardBody" v-else>
              <div
                class="cardRow"
                v-for="(item, index) in activityInfoLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="activityInfo[item.key]">
                  {{ activityInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card" v-if="this.free == 1">
            <div class="cardHeader">
              <div class="cardHeaderLeft">付款資訊</div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in payInfoLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="payInfo[item.key]">
                  {{ payInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">申請人</div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in applyInfoLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="applyInfo[item.key]">
                  {{ applyInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
        </div>
        <div class="contentRight">
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">同伴資訊</div>
              <div
                class="cardHeaderRight_edit"
                @click="peerShow"
                v-if="peerInfo.idcard && $route.query.isconfirm != 1"
              >
                編輯
              </div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in peerLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="peerInfo[item.key]">
                  {{ peerInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card" v-if="drawNotes || applyResult">
            <div class="cardHeader">
              <div class="cardHeaderLeft">其他</div>
              <div
                class="cardHeaderRight_edit"
                @click="otherShow"
                v-if="drawNotes"
              >
                編輯
              </div>
            </div>
            <div class="cardBody">
              <div class="cardRow" v-if="drawNotes">
                <div class="cardRowLeft">報名備註：</div>
                <div class="cardRowRight" v-if="drawNotes">{{ drawNotes }}</div>
                <div class="cardRowRight" v-else>-</div>
              </div>
              <div class="cardRow" style="margin-top:30px" v-if="applyResult">
                <div class="cardRowLeft">申請結果：</div>
                <div class="cardRowRight" v-if="applyResult">
                  {{ applyResult }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">中選記錄</div>
            </div>
            <div class="cardBody" v-if="selectRecord.length">
              <div
                class="cardRow"
                v-for="(item, index) in selectRecord"
                :key="index"
                :style="{
                  display: 'block',
                  marginTop: index > 0 ? '32px' : '0px'
                }"
              >
                <div class="cardRowRight">{{ item.applyName }}</div>
                <div class="cardRow" style="margin-top:13px">
                  <div class="cardRowLeft" style="font-size:0.12rem">
                    {{ item.selectedTime }}
                  </div>
                  <div
                    class="cardRowLeft"
                    style="font-size:0.12rem;margin-left:24px"
                  >
                    活動類型：{{
                      item.applyType == "1"
                        ? "一般活動"
                        : item.applyType == "2"
                        ? "演唱會"
                        : item.applyType == "4"
                        ? "見面會"
                        : item.applyType == "3"
                        ? "後臺活動"
                        : ""
                    }}
                  </div>
                </div>
              </div>
              <div class="paging-block clearfix">
                <el-pagination
                  class="paging fr"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="5"
                  :pager-count="5"
                  layout="prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
            <div class="cardBody" v-else>
              <div class="cardRow">
                <div class="cardRowLeft">中選記錄：</div>
                <div class="cardRowRight">-</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="編輯同伴資訊"
      :visible.sync="peerShowModal"
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog modalform">
        <el-form
          :model="peeruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div style="marginRight:110px">
            <el-form-item label="真實姓名" prop="realName">
              <el-input
                v-model="peeruleForm.realName"
                placeholder="请输入真實姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="證件號碼" prop="idcard">
              <el-input
                v-model="peeruleForm.idcard"
                placeholder="请输入證件號碼"
              ></el-input>
            </el-form-item>
            <div class="areacodeclass">
              <el-form-item label="手機號碼" prop="areacode">
                <el-input
                  v-model="peeruleForm.areacode"
                  placeholder="區號"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="phone">
                <el-input
                  v-model="peeruleForm.phone"
                  placeholder="请输入手機號碼"
                  @input="phoneNumberChange"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          class="btn borderBtn"
          style="marginRight:32px"
          @click="resetDefaultPeer"
        >
          恢復默認
        </div>
        <div class="btn" @click="submitForm('ruleForm')">修改</div>
      </span>
    </el-dialog>

    <el-dialog
      title="編輯報名備註"
      :visible.sync="otherShowModal"
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog modalform">
        <el-form
          :model="otherruleForm"
          :rules="detailrules"
          ref="ruleFormdetail"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div style="marginRight:50px">
            <el-form-item label="報名備註" prop="drawNotes">
              <el-input
                type="textarea"
                :rows="2"
                v-model="otherruleForm.drawNotes"
                placeholder="请输入報名備註"
                :maxlength="255"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          class="btn borderBtn"
          style="marginRight:32px"
          @click="resetDefaultOther"
        >
          恢復默認
        </div>
        <div class="btn" @click="submitFormDetail('ruleFormdetail')">修改</div>
      </span>
    </el-dialog>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "活動 / 活動列表 / 活動抽簽",
      navtitle: "查看詳情",
      dialogVisible: false,
      peerShowModal: false,
      otherShowModal: false,
      drawInfo: {},
      activityInfo: {},
      payInfo: {},
      applyInfo: {},
      peerInfo: {},
      drawStatus: "",
      drawNotes: "",
      applyResult: "",
      currentPage: 1,
      total: 5,
      selectRecord: [],
      free: "",
      peeruleForm: {
        realName: "",
        idcard: "",
        areacode: "",
        phone: ""
      },
      otherruleForm: {
        drawNotes: ""
      },
      rules: {
        realName: [
          { required: true, message: "请输入真實姓名", trigger: "change" }
        ],
        idcard: [
          { required: true, message: "请输入證件號碼", trigger: "change" }
        ],
        areacode: [
          { required: true, message: "請輸入區號", trigger: "change" }
        ],
        phone: [
          { required: true, message: "请输入手機號碼", trigger: "change" }
        ]
      },
      detailrules: {
        drawNotes: [
          { required: true, message: "请输入報名備註", trigger: "change" }
        ]
      },
      drawInfoLabel: [
        {
          label: "報名編號：",
          key: "drawNum"
        },
        {
          label: "報名日期：",
          key: "drawTime"
        },
        {
          label: "報名狀態：",
          key: "drawStatus"
        }
      ],
      activityInfoLabel: [
        {
          label: "活動名稱：",
          key: "activityName"
        },
        {
          label: "活動類型：",
          key: "activityType"
        },
        {
          label: "活動費用：",
          key: "activityCost"
        }
      ],
      activityInfoLabels: [
        {
          label: "活動名稱：",
          key: "activityName"
        },
        {
          label: "活動類型：",
          key: "activityType"
        },
        {
          label: "活動費用：",
          key: "activityCost"
        },
        {
          label: "活動地區：",
          key: "land"
        }
      ],
      payInfoLabel: [
        {
          label: "付款日期",
          key: "payTime"
        },
        {
          label: "付款方式",
          key: "payMethod"
        },
        {
          label: "流水編號",
          key: "payFlowId"
        },
        {
          label: "平臺交易號",
          key: "oidPartner"
        }
      ],
      applyInfoLabel: [
        {
          label: "會員編號：",
          key: "memberAccount"
        },
        {
          label: "用戶帳號：",
          key: "userAccount"
        },
        {
          label: "真實姓名：",
          key: "realName"
        },
        {
          label: "會籍起始時間：",
          key: "memberStart"
        },
        {
          label: "會籍到期時間：",
          key: "memberEnd"
        },
        {
          label: "證件號碼：",
          key: "idcard"
        },
        {
          label: "手機號碼：",
          key: "phone"
        },
        {
          label: "地區：",
          key: "area"
        }
      ],
      peerLabel: [
        {
          label: "真實姓名：",
          key: "realName"
        },
        {
          label: "證件號碼：",
          key: "idcard"
        },
        {
          label: "手機號碼：",
          key: "phone"
        }
      ]
    };
  },
  computed: {},
  created() {
    this.getDrawDetail();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    getDrawDetail() {
      this.$get(
        `/request/apply/application/detail?page=${this.currentPage}&size=5&id=${this.$route.query.id}`
      ).then(res => {
        if (res.code == "00000") {
          (this.free = res.data.free),
            (this.drawInfo = {
              drawNum: res.data.id,
              drawTime: res.data.applyTime,
              drawStatus:
                res.data.status == 0
                  ? "待抽籤"
                  : res.data.status == 1
                  ? "待付款"
                  : res.data.status == 2
                  ? "未抽中"
                  : res.data.status == 3
                  ? "已付款"
                  : res.data.status == 4
                  ? "已取消"
                  : res.data.status == 5
                  ? "已過期"
                  : res.data.status == 6
                  ? "已抽中"
                  : ""
            });
          this.activityInfo = {
            activityName: res.data.applyName,
            activityType:
              res.data.applyType == 1
                ? "一般活動"
                : res.data.applyType == 2
                ? "演唱會"
                : res.data.applyType == 4
                ? "見面會"
                : res.data.applyType == 3
                ? "後臺活動"
                : "",
            activityCost:
              res.data.free == 0
                ? res.data.freeContent
                : res.data.price + "CNY/" + res.data.twdPrice + "TWD",
            land: res.data.land == 0 ? "大陸" : "非大陸"
          };
          this.applyInfo = {
            memberAccount: res.data.memberId,
            userAccount: res.data.username,
            realName: res.data.memberName,
            memberStart: res.data.vipStartTime,
            memberEnd: res.data.vipEndTime,
            idcard: res.data.memberIdCard,
            phone: res.data.memberPhone,
            area: res.data.district
          };
          if (res.data.payFlowDto) {
            this.payInfo = {
              payTime: res.data.payFlowDto.payTime,
              payMethod: res.data.payFlowDto.payMethod,
              payFlowId: res.data.payFlowDto.payFlowId,
              oidPartner: res.data.payFlowDto.oidPartner
            };
          }
          this.peerInfo = {
            realName: res.data.companionName,
            idcard: res.data.companionIdCard,
            areacode: res.data.companionAreaCode,
            phone: res.data.companionMobile
          };
          this.drawNotes = res.data.comment;
          this.applyResult = res.data.applyResult;
          this.selectRecord = res.data.selectedRecord;
          this.total = res.data.allRow;
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    peerShow() {
      this.resetDefaultPeer();
      this.peerShowModal = true;
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 0);
    },
    resetDefaultPeer() {
      let current = JSON.parse(JSON.stringify(this.peerInfo));
      this.peeruleForm = current;
    },
    otherShow() {
      this.resetDefaultOther();
      this.otherShowModal = true;
    },
    resetDefaultOther() {
      let drawNotes = this.drawNotes;
      this.otherruleForm = {
        drawNotes
      };
    },
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getDrawDetail();
    },
    phoneNumberChange(val) {
      let filteredValue = val.replace(/\D/g, "");
      if (filteredValue.length > 11) {
        filteredValue = filteredValue.slice(0, 11);
      }
      this.peeruleForm.phone = filteredValue;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.handleChangeDetail("peer");
        } else {
          return false;
        }
      });
    },
    submitFormDetail(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.handleChangeDetail("detail");
        } else {
          return false;
        }
      });
    },
    handleChangeDetail(type) {
      let param = {
        id: this.drawInfo.drawNum
      };
      if (type == "peer") {
        param = {
          ...param,
          name: this.peeruleForm.realName,
          idCard: this.peeruleForm.idcard,
          areaCode: this.peeruleForm.areacode,
          mobile: this.peeruleForm.phone,
          comment: this.drawNotes ? this.drawNotes : ""
        };
      } else if (type == "detail") {
        param = {
          ...param,
          comment: this.otherruleForm.drawNotes
            ? this.otherruleForm.drawNotes
            : ""
        };
      }
      this.$post(
        `/request/apply/edit/application/detail`,
        param,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        this.peerShowModal = false;
        this.otherShowModal = false;
        if (res.code == "00000") {
          this.dialogVisible = true;
          if (type == "peer") {
            this.$propMessage("同伴資訊修改成功", "success", () => {
              this.getDrawDetail();
              this.dialogVisible = false;
            });
          } else {
            this.$propMessage("其他修改成功", "success", () => {
              this.getDrawDetail();
              this.dialogVisible = false;
            });
          }
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.rowdelete {
  display: flex;
  align-items: center;
  .rowdeleteTitle {
    color: rgba(41, 41, 41, 1);
    font-size: 14px;
    font-weight: 500;
    margin-left: 8px;
  }
}
.line {
  height: 0.5px;
  background: rgba(238, 238, 238, 1);
  width: 100%;
  margin-top: 9px;
  margin-bottom: 9px;
}
.el-button--mini {
  padding: 5px 9px;
}
.areacodeclass {
  display: flex;
  > div:nth-child(1) {
    margin-right: 0px !important;
  }
  > div:nth-child(1) /deep/ .el-form-item__content {
    width: 80px !important;
  }
  > div:nth-child(2) /deep/ .el-form-item__content {
    width: 200px !important;
  }
}
.contentDetails {
  .paddingContent {
    width: 100%;
    overflow: auto;
    background: none;
  }
  .box-card {
    width: 100%;
    min-width: 300px;
    background: #fafafd;
    border-radius: 12px;
    margin-bottom: 44px;
    .cardHeader {
      height: 68px;
      background: #f2f2f6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 3px solid #e5e4ea;
      padding: 20px;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      .cardHeaderLeft {
        font-size: 0.16rem;
        color: #6c3dea;
      }
      .cardHeaderRight_edit {
        padding: 5px 16px;
        border: 1px solid #6c3dea;
        border-radius: 4px;
        color: #6c3dea;
        cursor: pointer;
      }
    }
    .cardBody {
      padding: 20px;
      .cardRow {
        display: flex;
        .cardRowLeft {
          color: #938ea4;
          font-size: 0.14rem;
          text-align: left;
          width: 140px;
          flex-shrink: 0;
        }
        .allpointer {
          div {
            cursor: pointer !important;
          }
        }
        .cardRowRight {
          color: #292929;
          font-size: 0.14rem;
          text-align: left;
          word-break: break-all;
        }
        .cardRowRight_status {
          padding: 4px 8px;
          background: #6c3dea;
          color: #ffffff;
          font-size: 0.14rem;
          border-radius: 4px;
        }
        .coverbig {
          width: 80px;
          height: 80px;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 4px;
          background: rgba(41, 41, 41, 1);
          opacity: 0.6;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .shoplist {
    .shoplist_top {
      text-align: left;
      color: #292929;
      font-size: 0.14rem;
    }
    .shoplist_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .shoplist_detail {
        color: #292929;
        opacity: 0.6;
        font-size: 0.12rem;
      }
      .shoplist_num {
        color: #938ea4;
        font-size: 0.14rem;
      }
      .shoplist_price {
        color: #292929;
        font-size: 0.14rem;
        width: 110px;
        text-align: right;
      }
    }
    .shoprow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .shoplist_topin {
        font-size: 0.14rem;
        color: #121212;
        font-weight: 500;
      }
      .shopdetail {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        flex-shrink: 0;
        span {
          font-size: 0.14rem;
          color: #292929;
          opacity: 0.6;
        }
      }
    }
    .shopprice {
      color: #6c3dea;
      opacity: 0.8;
      font-size: 0.14rem;
      text-align: right;
      font-weight: 500;
    }
  }
  .shopinback {
    background: #f5f5fc;
    border-radius: 4px;
    padding: 23px 12px 23px 12px;
    margin-top: 27px;
  }
  .line {
    height: 0.5px;
    background: #d9d7e0;
    width: 100%;
    margin-top: 32px;
  }
  .linee {
    height: 0.5px;
    background: #eeeeee;
    width: 100%;
    margin-top: 25px;
  }
  .shop_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .texttypelow {
      color: #292929;
      opacity: 0.6;
      font-size: 0.14rem;
    }
    .typeinlow {
      color: #938ea4;
      font-size: 0.14rem;
    }
    .texttypemiddle {
      color: #292929;
      opacity: 0.6;
      font-size: 0.14rem;
    }
    .texttypedeep {
      color: #292929;
      opacity: 1;
      font-size: 0.14rem;
    }
  }
  .remark_box {
    width: 100%;
    min-width: 300px;
    background: #fafafd;
    border-radius: 12px;
    margin-bottom: 44px;
    padding: 20px;
    .remark_box_button {
      display: flex;
      justify-content: flex-end;
      margin-top: 32px;
    }
    .remark_box_input {
      position: relative;
    }
    /deep/ .el-textarea__inner {
      text-indent: 80px;
    }
    .remark_box_text {
      position: absolute;
      z-index: 10;
      color: #292929;
      left: 20px;
      line-height: 46px;
      font-size: 0.14rem;
    }
  }
  /deep/ .el-dialog {
    border-radius: 12px;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #eeeeee;
  }
  .formpadding {
    padding-left: 11px;
    /deep/ .el-form-item__content {
      margin-left: 9px !important;
    }
  }
  /deep/ .el-form-item__content {
    margin-left: 20px !important;
  }
  /deep/ .el-form-item__label:before {
    color: #6c3dea !important;
  }
  /deep/ .el-form-item__label {
    flex-shrink: 0;
  }
  /deep/ .el-form {
    padding-left: 0rem;
  }
  .threeinline {
    display: flex;
    align-items: center;
    /deep/ .el-form-item__content {
      width: 90px;
    }
    /deep/ .el-form-item {
      margin-right: 0px;
    }
  }
  .addressdetail {
    /deep/ .el-form-item__content {
      margin-left: 120px !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media screen and (min-width: 934px) {
    .paddingContent {
      min-width: 800px;
      overflow: auto;
      .contentbox {
        display: flex;
      }
      .contentLeft {
        width: 48%;
      }
      .contentRight {
        width: 48%;
        margin-left: 4%;
      }
    }
  }
  @media screen and (max-width: 934px) {
    .paddingContent {
      min-width: 500px;
      overflow: auto;
      .contentbox {
        display: block;
      }
      .contentLeft {
        width: 100%;
      }
      .contentRight {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activityDrawDetail.vue